export default "__VITE_ASSET__CTmkRX$s__"